import { Injectable } from '@angular/core';
import { AddedToCartDialogEventListener } from '@spartacus/cart/base/components';
import { CartUiEventAddToCart } from '@spartacus/cart/base/root';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomAddedToCartDialogEventListener extends AddedToCartDialogEventListener {
  protected override openModal(event: CartUiEventAddToCart): void {
    const addToCartData = {
      productCode: event.productCode,
      quantity: event.quantity,
      numberOfEntriesBeforeAdd: event.numberOfEntriesBeforeAdd,
      pickupStoreName: event.pickupStoreName,
    };

    // MODAL_CART is used instead of enum LAUNCH_CALLER.ADDED_TO_CART
    // MODAL_CART is defined in custom PLP module
    const dialog = this.launchDialogService.openDialog('MODAL_CART', undefined, undefined, addToCartData);

    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }
}
